import { groupRequestsSlice } from './slice';

export const { actions, reducer } = groupRequestsSlice;
export { selectors } from './adapter';
export * as thunks from './thunks';
export * from './types';
